import {Space, Row, Col, Button, Typography, Popover, Form} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {
  ColumnPopoverDisplay,
  ListActionButton,
  ModalCustom,
  Search,
} from "components/common";
import {employeeService} from "api";
import {ExcelSVG} from "assets";
import {
  itemsInputField as inputFieldsInit,
  allColumns,
} from "./ListEmployee.config";
import {setActiveKey} from "redux/reducer/common";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  setIdEmployee,
  searchEmployeeAPI,
  getChucVuAPI,
  getDanToc,
  getNation,
  getPhongBanAPI,
  setAdd,
  setEdit,
  getTonGiao,
  clearEmployee,
  getNoiCap,
  setEmployeeMode,
  getWord,
} from "redux/reducer/employee";
import {FORMAT_TIME, tabKeys} from "../../../../../../types/enums";
import axiosClient from "../../../../../../api/axiosClient";
import {fields as dataFields} from "../Detail/EmployeeInfo/config";
import "moment/locale/vi";
import Icons from "../../../../../../assets/icons";
import {ColumnProps} from "../../../../../../types/models";
import Notification from "../../../../../../components/common/notification/notification";
import {
  generateFileName,
  saveTableOptions,
  getTableOptions,
  formatDateToString,
} from "../../../../../../helper/common"; // Import locale if needed
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import "./Color.scss";
import {current} from "@reduxjs/toolkit";
import moment from "moment";
import dayjs from "dayjs";
import {EMPLOYEE_MODE} from "types/enums/employee";
import usePermission from "hooks/usePermission";
import FormTemplates from "./FormTemplates";
import WordAddres from "../Catalog/subcomponents/WordAddress/WordAddress";

const ListEmployees = ({setIsTabDisabled, setIsTabDisabledCT}) => {
  let savedTableOption = getTableOptions(
    "LISTEMPLOYEES_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const {isAdminHCNS} = usePermission();
  const dispatch = useAppDispatch();
  const employeesStore = useAppSelector(state => state.employeesReducer);
  let idEmp = useAppSelector(state => state.employeesReducer.idEmp);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileInputRef1 = useRef<HTMLInputElement>(null);
  const expandRef = useRef<any>();

  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter(e => e.show === true)
  );
  columns.map(e => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const modalRefFormTemplates = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 1000,
  });
  const [paramss, setParamss] = useState<any>({});
  const [isDisabledButton, setIsDisabledButton] = useState(true);
  const [fieldStates, setFieldStates] = useState(dataFields);
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      const record = selectedRows[0];

      dispatch(setIdEmployee(record.id));
      // setAdd(false), setEdit(false));
      dispatch(setAdd(false));
      dispatch(setEdit(false));
      setIsTabDisabled(false);
      setIsTabDisabledCT(false);
    },
  };
  const activeTab = useAppSelector(e => e.common.activeTab);
  useEffect(() => {
    getListEmployee(params);
  }, [params, activeTab]);
  useEffect(() => {
    // Fetch data only if it's not present in local storage
    const tonGiaoList = JSON.parse(localStorage.getItem("tonGiaoList"));
    if (!tonGiaoList) {
      dispatch(getTonGiao());
    }

    const quocTichList = JSON.parse(localStorage.getItem("quocTichList"));
    if (!quocTichList) {
      dispatch(getNation());
    }

    const chucVuList = JSON.parse(localStorage.getItem("chucVuList"));
    if (!chucVuList) {
      dispatch(
        getChucVuAPI({
          page: 1,
          limit: 1000,
        })
      );
    }

    const phongBanList = JSON.parse(localStorage.getItem("phongBanList"));
    if (!phongBanList) {
      dispatch(
        getPhongBanAPI({
          page: 1,
          limit: 1000,
        })
      );
    }

    const danTocList = JSON.parse(localStorage.getItem("danTocList"));
    if (!danTocList) {
      dispatch(getDanToc());
    }

    const noiCap = JSON.parse(localStorage.getItem("noiCap"));
    if (!noiCap) {
      dispatch(getNoiCap());
    }
    const word = JSON.parse(localStorage.getItem("idDiaChiLamViec"));
    if (!word) {
      dispatch(
        getWord({
          page: 1,
          limit: 1000,
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    setOptionsTGFields(employeesStore.tonGiaoList, "tonGiao");
  }, [employeesStore.tonGiaoList]);

  useEffect(() => {
    setOptionsQTFields(employeesStore.quocTichList, "quocTich");
  }, [employeesStore.quocTichList]);
  //
  useEffect(() => {
    setOptionsSearchFields(employeesStore.danTocList, "danToc");
  }, [employeesStore.danTocList]);
  //
  useEffect(() => {
    setOptionsCVFields(employeesStore.chucVuList, "idChucVu");
  }, [employeesStore.chucVuList]);
  useEffect(() => {
    setOptionsPBFields(employeesStore.phongBanList, "idPhongBan");
  }, [employeesStore.phongBanList]);
  useEffect(() => {
    getListEmployee({
      ...params,
    });
  }, [params]);
  useEffect(() => {
    setOptionsNoiCap(employeesStore.noiCap, "noiCap");
  }, [employeesStore.noiCap]);
  const setOptionsNoiCap = (list, noiCap) => {
    if (inputFieldsInit.find(field => field.name === noiCap)) {
      inputFieldsInit.find(field => field.name === noiCap).options = list?.map(
        item => ({
          value: item.noiCap,
          label: item.noiCap,
        })
      );
      setFieldStates([...fieldStates]);
    }
  };
  useEffect(() => {
    setData(
      employeesStore.employeesList.map(employees => ({
        ...employees,
        key: employees.id,
        idChucVu: employees.idChucVu !== null ? employees.idChucVu : "_",
      }))
    );
  }, [employeesStore.employeesList]);
  useEffect(() => {
    columns.forEach(column => {
      if (column.dataIndex === "idVaiTro") {
        column.render = (text, record, index) => {
          //console.log("text",text);
          // Kiểm tra nếu giá trị của cột là 1, hiển thị "Giám Đốc"
          if (Array.isArray(text) && text.length === 1 && text[0] === 1) {
            return "Bác sĩ";
          } else {
            // Nếu không, trả về giá trị gốc
            return "";
          }
        };
      }
    });
  }, [columns]); // Thực hiện hiệu chỉnh mỗi khi columns thay đổi
  useEffect(() => {
    columns.map(index => {
      if (index.dataIndex === "trangThai") {
        index.render = (v, r, i) => {
          const backgroundColors = {
            "Đang làm việc": "#00b335",
            "Đã Nghỉ Việc": "#f52439",
          };
          const backgroundColor = backgroundColors[v] || "";
          return (
            <div className="color-column" style={{backgroundColor}}>
              {v}
            </div>
          );
        };
      }
    });
  }, []);
  const setOptionsTGFields = (list, name) => {
    if (inputFieldsInit.find(field => field.name === name)) {
      inputFieldsInit.find(field => field.name === name).options = list?.map(
        item => ({
          value: item.name,
          label: item.name,
        })
      );
    }
  };
  const setOptionsSearchFields = (list, name) => {
    if (inputFieldsInit.find(field => field.name === name)) {
      inputFieldsInit.find(field => field.name === name).options = list?.map(
        item => ({
          value: item.name,
          label: item.name,
        })
      );
    }
  };
  const setOptionsQTFields = (list, nameVN) => {
    if (inputFieldsInit.find(field => field.name === nameVN)) {
      inputFieldsInit.find(field => field.name === nameVN).options = list?.map(
        item => ({
          value: item.nameVN,
          label: item.nameVN,
        })
      );
    }
  };
  const setOptionsCVFields = (list, tenChucVu) => {
    if (inputFieldsInit.find(field => field.name === tenChucVu)) {
      inputFieldsInit.find(field => field.name === tenChucVu).options =
        list?.map(item => ({
          value: item.id,
          label: item.tenChucVu,
        }));
    }
  };
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (inputFieldsInit.find(field => field.name === tenPhongBan)) {
      inputFieldsInit.find(field => field.name === tenPhongBan).options =
        list?.map(item => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  const setShowColumnsList = showColumns => {
    saveTableOptions(
      "LISTEMPLOYEES_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const onClickSearchEmployee = async () => {
    setCurrentPage(1);
    //  var searchFields = expandRef?.current?.getData();
    //setParams({ ...params, ...searchFields, page: 1}); // Đặt trang về 1 khi thực hiện tìm kiếm
    const formValue = expandRef?.current?.getData();
    const searchFields = {
      ...formValue,
      ngayCapDto: formatDateToString(formValue.ngayCapDto, FORMAT_TIME.dayFull),
      birthday: formatDateToString(formValue.birthday, FORMAT_TIME.dayFull),
    };
    setParams({...formValue, ...params, ...searchFields, page: 1});
  };
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({...params, page: currentPage, limit: pageSize});
  };
  const getListEmployee = async params => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(searchEmployeeAPI(params));
    setLoading(false);
  };

  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };
  const onAdd = async () => {
    dispatch(setEdit(false));
    dispatch(setIdEmployee(null));
    dispatch(clearEmployee(false));
    dispatch(setAdd(true));
    dispatch(setActiveKey(tabKeys.EMPLOYEE.DETAIL));
    setIsTabDisabled(true);
    setIsTabDisabledCT(false);
    dispatch(setEmployeeMode(EMPLOYEE_MODE.CREATE));
  };
  const handleOnDelete = async id => {
    setLoading(true);
    try {
      await employeeService.deleteEmployee(id).then(res => {
        Notification("success", "Xoá thành công");
        setLoading(false);
      });
    } catch (error) {
      Notification("error", " Xóa nhân viên thất bại");
      setLoading(false);
    }
    getListEmployee(params);
  };
  const handleView = id => {
    dispatch(setActiveKey(tabKeys.EMPLOYEE.DETAIL));
    dispatch(setEdit(false));
    dispatch(setIdEmployee(id));
    dispatch(setAdd(false));
    setIsTabDisabled(false);
    setIsTabDisabledCT(false);
    dispatch(setEmployeeMode(EMPLOYEE_MODE.VIEW));
  };
  const handleEdit = id => {
    dispatch(setActiveKey(tabKeys.EMPLOYEE.DETAIL));
    setIsTabDisabled(false);
    dispatch(setEdit(false));
    dispatch(setAdd(true));
    dispatch(setIdEmployee(id));
    setIsTabDisabledCT(false);
    dispatch(setEmployeeMode(EMPLOYEE_MODE.EDIT));
  };
  useEffect(() => {
    const newColumns = columns;
    columns.find(e => {
      if (e.dataIndex == "action") {
        e.render = (
          value,
          _record: {
            id: number | string;
          },
          index
        ) => {
          return (
            <ListActionButton
              deleteFunction={() => handleOnDelete(_record.id)}
              editFunction={() => handleEdit(_record.id)}
              showDetailFunction={() => handleOnShowDetail(_record.id)}
              disabled={{
                deleteFunction: !isAdminHCNS(),
                editFunction: !isAdminHCNS(),
              }}
            ></ListActionButton>
          );
        };
      }
    });
    setColumns(newColumns);
  }, []);

  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({...paramss, ...searchFields});
    handleExportExcel(params);
  };
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const excel = event.target.files[0];
      const formData = new FormData();
      formData.append("files", excel);
      try {
        const response = await employeeService.uploadEmployee(formData);
        if (response.data.code === "400") {
          Notification("error", response.data.message);
        } else if (response.data.data.length !== 0) {
          let dong = "";
          for (let i = 0; i < response.data.data.length; i++) {
            dong = dong + response.data.data[i].errorLine + ",";
          }
          dong = dong.replace(/,$/, "");
          Notification(
            "warning",
            "Không import được dòng " + dong + " đang gặp lỗi"
          );
        } else {
          Notification("success", "import file excel thành công");
          onClickSearchEmployee();
        }
      } catch (err) {
        Notification("error", "Lỗi khi import file excel");
      }
    }
  };
  const handleUploadHD = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const excel = event.target.files[0];
      const formData = new FormData();
      formData.append("files", excel);
      try {
        const response = await employeeService.uploadHD(formData);
        if (response.data.code === "400") {
          Notification("error", response.data.message);
        } else if (response.data.data.length !== 0) {
          let dong = "";
          for (let i = 0; i < response.data.data.length; i++) {
            dong = dong + response.data.data[i].errorLine + ",";
          }
          dong = dong.replace(/,$/, "");
          Notification(
            "warning",
            "Không import được dòng " + dong + " đang gặp lỗi"
          );
        } else {
          Notification("success", "import file excel thành công");
          onClickSearchEmployee();
        }
      } catch (err) {
        Notification("error", "Lỗi khi import file excel");
      }
    }
  };
  const handleClick = () => {
    fileInputRef.current.value = null;
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleClick1 = () => {
    fileInputRef1.current.value = null;
    if (fileInputRef1.current) {
      fileInputRef1.current.click();
    }
  };
  const handleExportExcel = async params => {
    const url = "hanhchinhnhansu/nhan-vien/export-excel";
    const baseName = "danh-sach-nhan-vien";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };

  const handleOnShowDetail = id => {
    dispatch(setActiveKey(tabKeys.EMPLOYEE.DETAIL));
    setIsTabDisabled(false);
    dispatch(setAdd(false));
    dispatch(setEdit(false));
    dispatch(setEmployeeMode(EMPLOYEE_MODE.VIEW));
    dispatch(setIdEmployee(id));
    setIsTabDisabledCT(false);
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearchEmployee();
    }
  };
  // Xác định độ dài của mảng columns
  const numberOfColumns = columns.length;

  // Thiết lập giá trị scroll dựa vào số lượng cột
  let scrollX;
  if (numberOfColumns <= 5) {
    scrollX = 1000;
  } else if (numberOfColumns <= 10) {
    scrollX = 1600;
  } else if (numberOfColumns <= 15) {
    scrollX = 2000;
  } else if (numberOfColumns <= 20) {
    scrollX = 3000;
  } else if (numberOfColumns <= 25) {
    scrollX = 4000;
  } else if (numberOfColumns <= 30) {
    scrollX = 5000;
  } else if (numberOfColumns <= 35) {
    scrollX = 6000;
  } else if (numberOfColumns <= 40) {
    scrollX = 7000;
  } else {
    scrollX = 9000;
  }

  return (
    <div className="employee-list" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="employee-container">
        <div className="container">
          <Search
            ref={expandRef}
            fields={inputFieldsInit}
            onClickSearch={onClickSearchEmployee}
            showAdvancedSearch={true}
          />
        </div>
        <div className="container">
          <Space style={{width: "100%"}} direction="vertical">
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      width={"600px"}
                      columns={defaultColumns}
                      columnSizes={{xs: 10, sm: 12, md: 8, lg: 8, xl: 8}}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button icon={<Icons.bars />} className="btn-sub">
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
              <Col className="upload-hd">
                <Space style={{width: "100%"}}>
                  <Button
                    className="custom-btn"
                    icon={<ExcelSVG />}
                    onClick={() => modalRefFormTemplates.current?.openModal()}
                  >
                    <Typography>Mẫu in</Typography>
                  </Button>
                  <Button
                    icon={<Icons.upload />}
                    className="btn-sub"
                    onClick={handleClick1}
                    style={{
                      width: "220px",
                      textAlign: "center",
                    }}
                  >
                    Import hợp đồng lao động
                  </Button>
                  <input
                    type="file"
                    style={{display: "none"}}
                    onChange={handleUploadHD}
                    ref={fileInputRef1}
                  />
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExport}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                  <input
                    type="file"
                    style={{display: "none"}}
                    onChange={handleUpload}
                    ref={fileInputRef}
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-sub"
                    onClick={handleClick}
                    style={{
                      width: "100px",
                    }}
                  >
                    Import
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      onAdd();
                    }}
                    disabled={!isAdminHCNS()}
                  >
                    Thêm mới
                  </Button>
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                rowSelection={{
                  type: "radio",
                  ...rowSelection,
                }}
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employeesStore.employeesTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    onDoubleClick: e => handleView(record.id),
                  };
                }}
                rowKey={record => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{x: scrollX}}
              />
            )}
            <ModalCustom
              ref={modalRefFormTemplates}
              width={800}
              title={`Mẫu in`}
              centered
            >
              <FormTemplates />
            </ModalCustom>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ListEmployees;
